/**
 * @generated SignedSource<<496b155eb6c35994d9d26ec4b78ed08a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StoreStuffDeleteInput = {
  id: string;
};
export type StoreStuffId_storeStuffDeleteMutation$variables = {
  input: StoreStuffDeleteInput;
};
export type StoreStuffId_storeStuffDeleteMutation$data = {
  readonly storeStuffDelete: {
    readonly id: string;
  };
};
export type StoreStuffId_storeStuffDeleteMutation = {
  response: StoreStuffId_storeStuffDeleteMutation$data;
  variables: StoreStuffId_storeStuffDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreStuffId_storeStuffDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuffDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreStuffId_storeStuffDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuffDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2aa5f4bbddf275b2c1d0dc79bf346c64",
    "id": null,
    "metadata": {},
    "name": "StoreStuffId_storeStuffDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation StoreStuffId_storeStuffDeleteMutation(\n  $input: StoreStuffDeleteInput!\n) {\n  storeStuffDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "56b2a82e85323c4e00f483868c793c74";

export default node;
